/**
 * @file Album Folder Tag Search Actions.
 */

import { ALBUM_FOLDER_TAG_SEARCH_FILTER_TYPE } from '../constants/album-folder-tags';

export const UPDATE_FILTER = 'album_folder_tag_search/UPDATE_FILTER';

export const updateFilter = (
  filter,
  entityId,
  filterMode = ALBUM_FOLDER_TAG_SEARCH_FILTER_TYPE.ALL,
) => {
  return { type: UPDATE_FILTER, filter, entityId, filterMode };
};
